import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconMail.module.css';

const IconMail = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 1920 1920"
    >
      <path
        id="SVGRepo_iconCarrier"
        fillRule="evenodd"
        d="M0 1694.235h1920V226H0zM112.941 376.664V338.94H1807.06v37.723L960 1111.233l-847.059-734.57ZM1807.06 526.198v950.513l-351.134-438.89-88.32 70.475 378.353 472.998H174.042l378.353-472.998-88.32-70.475-351.134 438.89V526.198L960 1260.768z"
      ></path>
    </svg>
  );
};

IconMail.defaultProps = {
  rootClassName: null,
  className: null,
  fillColor: null,
};

IconMail.propTypes = {
  rootClassName: string,
  className: string,
  fillColor: string,
};

export default IconMail;
